import React, { useEffect, useState } from "react";
import "./channelMember.css";
import AdminMember from "./Member_Container/AdminMember";
import IndividualsMember from "./Member_Container/IndividualsMember";
import GroupsMember from "./Member_Container/GroupsMember";
import axios from "../../../../../axios";
import IndividualsMemberForStudents from "./Member_Container/IndividualsMemberForStudents";
import AddMemebers from "../../Create_channel_screen/AddMemebers";
import CreateSuccessfulChannel from "../../Create_successful/CreateSuccessfulChannel";
import SaveChangesConfirm from "./SaveChangesConfirm";
import { Box, Typography, Button } from "@mui/material";
import AddedSuccessfulMember from "./AddedSuccessfulMember";

const ChannelMember = ({ community, setIsMemberUpdated, isMemberUpdated }) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [inEditingMode, setInEditingMode] = useState(false);
  const [inAddingMode, setInAddingMode] = useState(false);
  const [allMembers, setAllMembers] = useState({
    admins: [],
    teachers: [],
    students: [],
  });
  const [stdParent, setStdParent] = useState([]);

  const [secParent, setSecParent] = useState([]);
  const [
    selectedStudentListClassStateParent,
    setSelectedListStudentClassStateParent,
  ] = useState([]);

  const { admins, teachers, students } = allMembers;
  const [openSuccessful, setOpenSuccessfull] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [editingAllMembersDetails, setEditingAllMembersDetails] = useState([]);
  const [deletingAllMembersDetails, setDeletingAllMembersDetails] = useState({
    deletingStudents: [],
    deletingTeachers: [],
    deletingGroups: [],
    deletingAdmins: [],
  });
  const { deletingStudents, deletingTeachers, deletingGroups, deletingAdmins } =
    deletingAllMembersDetails;

  useEffect(() => {
    const getMember = async () => {
      let res = await axios.get(`/api/v1/community/${community?.id}/getMember`);
      let admins = [];
      let teachers = [];
      let students = [];

      for (const member of res.data.data.members) {
        if (member.admins_id && member.admins_id.length > 0) {
          admins.push(...member.admins_id);
        }
        if (member.teachers_id && member.teachers_id.length > 0) {
          teachers.push(...member.teachers_id);
        }
        if (member.students_id && member.students_id.length > 0) {
          students.push(...member.students_id);
        }
      }

      setAllMembers({
        ...allMembers,
        admins: admins,
        teachers: teachers,
        students: students,
      });
    };
    getMember();
  }, [openSuccessful, isEdited]);

  const isAdmin = admins.some((admin) => admin.admin.id === teacher_id);

  console.log(isAdmin, "isAdmin");

  return (
    <>
      {!openSuccessful ? (
        <>
          {admins.length > 0 || teachers.length > 0 || students.length > 0 ? (
            <div className="d-flex flex-column">
              {/* OLD UI */}
              {/* <div className="editing_option_area py-1 px-2 d-flex align-items-center justify-content-between">
                <div>
                  <span className="total_member_text mr-3">Total Members</span>
                  <span style={{ color: "#AAAAAA" }}>
                    {admins.length + teachers.length + students.length}
                  </span>
                </div>
                {!inEditingMode ? (
                  <>
                    {community?.role !== "member" && (
                      <div className="d-flex align-items-center ml-5">
                        <div
                          className="ml-3 my-1 member_edit_button d-flex align-items-center justify-content-center"
                          onClick={() => setInEditingMode(!inEditingMode)}
                        >
                          Edit
                        </div>
                        <div
                          onClick={() => setInAddingMode(!inAddingMode)}
                          className="ml-3 member_edit_button member_add_button d-flex align-items-center justify-content-center"
                        >
                          Add Members
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex my-2">
                    <button
                      disabled={isMemberUpdated}
                      onClick={() => {
                        setInEditingMode(!inEditingMode);
                        setEditingAllMembersDetails([]);
                        setDeletingAllMembersDetails({
                          deletingStudents: [],
                          deletingTeachers: [],
                          deletingGroups: [],
                          deletingAdmins: [],
                        });
                      }}
                      style={{ width: "80px", height: "30px" }}
                      className="ml-2 member_edit_button d-flex align-items-center justify-content-center"
                    >
                      Discard
                    </button>
                    {(deletingStudents.length > 0 ||
                      deletingTeachers.length > 0 ||
                      deletingGroups.length > 0 ||
                      deletingAdmins.length > 0 ||
                      editingAllMembersDetails.length > 0) && (
                      <button
                        disabled={isMemberUpdated}
                        autoFocus
                        // onClick={handleSaveChanges}
                        onClick={() => setConfirm(!confirm)}
                        style={{ width: "80px", height: "30px" }}
                        className="ml-2 member_edit_button member_add_button d-flex align-items-center justify-content-center no"
                      >
                        Save
                      </button>
                    )}
                  </div>
                )}
              </div> */}
              {/* New UI */}
              <Box
                sx={{
                  py: 1.5,
                  px: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  bgcolor: "#fff",
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1" fontWeight={600} mr={1}>
                    Total Members:
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {admins.length + teachers.length + students.length}
                  </Typography>
                </Box>

                {console.log(community?.role, "member role")}

                {!inEditingMode ? (
                  <>
                    {isAdmin && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Button
                          variant="outlined"
                          color="warning"
                          onClick={() => setInEditingMode(!inEditingMode)}
                          sx={{ ml: 1, borderRadius: 2 }}
                        >
                          ✏️ Edit
                        </Button>
                        <Button
                          variant="contained"
                          color="warning"
                          onClick={() => setInAddingMode(!inAddingMode)}
                          sx={{ ml: 1, borderRadius: 2 }}
                        >
                          ➕ Add Members
                        </Button>
                      </Box>
                    )}
                  </>
                ) : (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Button
                      variant="outlined"
                      color="inherit"
                      onClick={() => {
                        setInEditingMode(!inEditingMode);
                        setEditingAllMembersDetails([]);
                        setDeletingAllMembersDetails({
                          deletingStudents: [],
                          deletingTeachers: [],
                          deletingGroups: [],
                          deletingAdmins: [],
                        });
                      }}
                      sx={{ ml: 1, borderRadius: 2, minWidth: 90 }}
                    >
                      Cancel
                    </Button>
                    {(deletingStudents.length > 0 ||
                      deletingTeachers.length > 0 ||
                      deletingGroups.length > 0 ||
                      deletingAdmins.length > 0 ||
                      editingAllMembersDetails?.length > 0) && (
                      <Button
                        variant="contained"
                        color="warning"
                        disabled={!isMemberUpdated}
                        autoFocus
                        onClick={() => setConfirm(!confirm)}
                        sx={{ ml: 1, borderRadius: 2, minWidth: 90 }}
                      >
                        💾 Save
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
              {/* <div className="w-100">
                <div className="request_member_box pb-3 mt-2">
                  {admins?.length > 0 &&
                    [...admins]
                      .sort((a, b) =>
                        a.admin.id === teacher_id
                          ? -1
                          : b.admin.id === teacher_id
                          ? 1
                          : a.admin.id === community?.user_id?.id
                          ? -1
                          : b.admin.id === community?.user_id?.id
                          ? 1
                          : 0
                      )
                      .map((admin, index) => (
                        <AdminMember
                          inEditingMode={inEditingMode}
                          setEditingAllMembersDetails={
                            setEditingAllMembersDetails
                          }
                          creatorId={community?.user_id?.id}
                          editingAllMembersDetails={editingAllMembersDetails}
                          setDeletingAllMembersDetails={
                            setDeletingAllMembersDetails
                          }
                          deletingAllMembersDetails={deletingAllMembersDetails}
                          key={index}
                          admin={admin}
                        />
                      ))}
                </div>
                <div className="members_heading py-3">MEMBERS</div>
                {(teachers?.length > 0 || students?.length > 0) && (
                  <>
                    <div className="members_heading py-1 ms-4">Teachers</div>
                    <div className="col-11 p-0 ms-4 indivisual_box">
                      {teachers?.length > 0 &&
                        [...teachers]
                          .sort((a, b) =>
                            a.teacher.id === teacher_id
                              ? -1
                              : b.teacher.id === teacher_id
                              ? 1
                              : a.role === "moderator"
                              ? -1
                              : b.role === "moderator"
                              ? 1
                              : 0
                          )
                          .map((teacher, index) => (
                            <IndividualsMember
                              setEditingAllMembersDetails={
                                setEditingAllMembersDetails
                              }
                              editingAllMembersDetails={
                                editingAllMembersDetails
                              }
                              inEditingMode={inEditingMode}
                              setDeletingAllMembersDetails={
                                setDeletingAllMembersDetails
                              }
                              deletingAllMembersDetails={
                                deletingAllMembersDetails
                              }
                              key={index}
                              teacher={teacher}
                            />
                          ))}
                    </div>
                    <div className="members_heading py-1 ms-4 mt-4">
                      Students
                    </div>
                    <div className="col-11 p-0 ms-4 indivisual_box">
                      {students?.length > 0 &&
                        students.map((student, index) => (
                          <IndividualsMemberForStudents
                            inEditingMode={inEditingMode}
                            setDeletingAllMembersDetails={
                              setDeletingAllMembersDetails
                            }
                            deletingAllMembersDetails={
                              deletingAllMembersDetails
                            }
                            key={index}
                            student={student}
                          />
                        ))}
                    </div>
                  </>
                )}
                {community?.groups?.length > 0 && (
                  <div className="members_heading py-2 ms-4">Groups</div>
                )}
                <div className="col-11 p-0 ms-4 indivisual_box">
                  {community?.groups?.length > 0 &&
                    community?.groups?.map((group, index) => (
                      <GroupsMember
                        key={index}
                        setDeletingAllMembersDetails={
                          setDeletingAllMembersDetails
                        }
                        deletingAllMembersDetails={deletingAllMembersDetails}
                        inEditingMode={inEditingMode}
                        group={group}
                        communityId={community?.id}
                      />
                    ))}
                </div>
              </div> */}

              <Box sx={{ width: "100%" }}>
                <Box sx={{ pb: 3, mt: 2 }}>
                  {admins?.length > 0 &&
                    [...admins]
                      .sort((a, b) =>
                        a.admin.id === teacher_id
                          ? -1
                          : b.admin.id === teacher_id
                          ? 1
                          : a.admin.id === community?.user_id?.id
                          ? -1
                          : b.admin.id === community?.user_id?.id
                          ? 1
                          : 0
                      )
                      .map((admin, index) => (
                        <AdminMember
                          key={index}
                          admin={admin}
                          inEditingMode={inEditingMode}
                          setIsMemberUpdated={setIsMemberUpdated}
                          setEditingAllMembersDetails={
                            setEditingAllMembersDetails
                          }
                          creatorId={community?.user_id?.id}
                          editingAllMembersDetails={editingAllMembersDetails}
                          setDeletingAllMembersDetails={
                            setDeletingAllMembersDetails
                          }
                          deletingAllMembersDetails={deletingAllMembersDetails}
                        />
                      ))}
                </Box>

                <Typography variant="h6" sx={{ pl: 2, pb: 1 }}>
                  MEMBERS
                </Typography>

                {(teachers?.length > 0 || students?.length > 0) && (
                  <>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        pl: 4,
                        pb: 1,
                        color: "#1e88e5", // custom blue
                        fontWeight: 600,
                      }}
                      className="poppins-semibold"
                    >
                      Teachers ({teachers?.length})
                    </Typography>

                    <Box sx={{ pl: 4, pr: 2 }}>
                      {teachers?.length > 0 &&
                        [...teachers]
                          .sort((a, b) =>
                            a.teacher.id === teacher_id
                              ? -1
                              : b.teacher.id === teacher_id
                              ? 1
                              : a.role === "moderator"
                              ? -1
                              : b.role === "moderator"
                              ? 1
                              : 0
                          )
                          .map((teacher, index) => (
                            <IndividualsMember
                              setIsMemberUpdated={setIsMemberUpdated}
                              key={index}
                              index={index}
                              teacher={teacher}
                              inEditingMode={inEditingMode}
                              editingAllMembersDetails={
                                editingAllMembersDetails
                              }
                              setEditingAllMembersDetails={
                                setEditingAllMembersDetails
                              }
                              setDeletingAllMembersDetails={
                                setDeletingAllMembersDetails
                              }
                              deletingAllMembersDetails={
                                deletingAllMembersDetails
                              }
                            />
                          ))}
                    </Box>

                    <Typography
                      variant="subtitle1"
                      sx={{
                        pl: 4,
                        pb: 1,
                        color: "#1e88e5", // custom blue
                        fontWeight: 600,
                      }}
                      className="poppins-semibold"
                    >
                      Students ({students?.length})
                    </Typography>
                    <Box sx={{ pl: 4, pr: 2 }}>
                      {students?.length > 0 &&
                        students.map((student, index) => (
                          <IndividualsMemberForStudents
                            setIsMemberUpdated={setIsMemberUpdated}
                            key={index}
                            student={student}
                            inEditingMode={inEditingMode}
                            setDeletingAllMembersDetails={
                              setDeletingAllMembersDetails
                            }
                            deletingAllMembersDetails={
                              deletingAllMembersDetails
                            }
                          />
                        ))}
                    </Box>
                  </>
                )}

                {community?.groups?.length > 0 && (
                  <>
                    <Typography
                      variant="subtitle1"
                      sx={{ pl: 4, mt: 4, pb: 1 }}
                    >
                      Groups
                    </Typography>
                    <Box sx={{ pl: 4, pr: 2 }}>
                      {community.groups.map((group, index) => (
                        <GroupsMember
                          key={index}
                          group={group}
                          inEditingMode={inEditingMode}
                          communityId={community?.id}
                          setDeletingAllMembersDetails={
                            setDeletingAllMembersDetails
                          }
                          deletingAllMembersDetails={deletingAllMembersDetails}
                        />
                      ))}
                    </Box>
                  </>
                )}
              </Box>
              {inAddingMode && (
                <div className="create_channel_transprant_body">
                  <div className="create_channel_container">
                    {/* <img
                      src="/images/cross-circle3.svg"
                      className="channel_crossArrow"
                      alt=""
                      onClick={() => setInAddingMode(!inAddingMode)}
                    /> */}
                    <div className="p-4">
                      <AddMemebers
                        isAddingModel={inAddingMode}
                        setOpenSuccessfull={setOpenSuccessfull}
                        // setChannel={setChannel}
                        setInAddingMode={setInAddingMode}
                        community={community}
                        isAboutPage={true}
                        stdParent={stdParent}
                        setStdParent={setStdParent}
                        secParent={secParent}
                        teachers={teachers}
                        students={students}
                        setSecParent={setSecParent}
                        selectedStudentListClassStateParent={
                          selectedStudentListClassStateParent
                        }
                        setSelectedListStudentClassStateParent={
                          setSelectedListStudentClassStateParent
                        }
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="loader_container">
              <img
                className="request_post_loader"
                src="/gif/LoaderDot.gif"
                alt=""
              />
            </div>
          )}

          {confirm && (
            <SaveChangesConfirm
              deletingAllMembersDetails={deletingAllMembersDetails}
              setConfirm={setConfirm}
              editingAllMembersDetails={editingAllMembersDetails}
              isMemberUpdated={isMemberUpdated}
              setIsMemberUpdated={setIsMemberUpdated}
              community={community}
              isEdited={isEdited}
              setInEditingMode={setInEditingMode}
              setIsEdited={setIsEdited}
              inEditingMode={inEditingMode}
              setEditingAllMembersDetails={setEditingAllMembersDetails}
              setDeletingAllMembersDetails={setDeletingAllMembersDetails}
            />
          )}
        </>
      ) : (
        <>
          {/* <CreateSuccessfulChannel isMember={true} setOpenSuccessfull={setOpenSuccessfull} /> */}
          <AddedSuccessfulMember
            isMember={true}
            setOpenSuccessfull={setOpenSuccessfull}
            setInAddingMode={setInAddingMode}
          />
        </>
      )}
    </>
  );
};

export default ChannelMember;
